<template>
    <BreadCrumb PageTitle="Ajouter une Proposition de réponse" />
    <AddPropositionReponse />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddPropositionReponse from "@/components/PropositionReponse/AddPropositionReponse.vue";
  
    export default defineComponent({
      name: "AddPropositionReponsePage",
      components: {
        BreadCrumb,
        AddPropositionReponse,
      },
    });
  </script>